"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFormControlLabel = void 0;
var global_1 = require("../../global");
var colors_1 = require("../../generated/colors");
exports.MuiFormControlLabel = {
    styleOverrides: {
        root: {
            margin: "4px 0",
            "&:hover": {
                ".MuiCheckbox-root, .MuiRadio-root": {
                    backgroundColor: "transparent",
                    color: colors_1.colors.Grey1,
                    "&.Mui-checked": {
                        color: colors_1.colors.Primary,
                    },
                    "&.Mui-disabled": {
                        color: colors_1.colors.Grey4,
                    },
                },
            },
            ".MuiFormControlLabel-label": __assign(__assign({}, global_1.typography.regular16), { color: colors_1.colors.Text }),
        },
    },
};
//# sourceMappingURL=form-control-label.js.map